import React from "react";
import { Link } from "react-router-dom";
import { BsArrowRight } from "react-icons/bs";

export default function CandidatesInfo({ dashboardData }) {
  return (
    <>
      <div className="row recruitparent">
        <div className="col-md-6 ">
          <Link
            to={"/Candidates/AllApplicants"}
            style={{ textDecoration: "none" }}
          >
            <div className="maincontent">
              <div className="recruit_highlight">
                {dashboardData && dashboardData.length !== 0 ? (
                  <>
                    <h1>{dashboardData[0].applicant_count_all}</h1>
                  </>
                ) : (
                  ""
                )}
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h3>All Applicants</h3>
                  </div>
                  <div>
                    <BsArrowRight size={"30"} />
                  </div>
                </div>
              </div>
            </div>
          </Link>
        </div>
        <div className="col-md-6">
          <Link
            to={"/Candidates/ShortlistedApplicants"}
            style={{ textDecoration: "none" }}
          >
            <div className="maincontent">
              <div className="recruit_highlight">
                {dashboardData && dashboardData.length !== 0 ? (
                  <>
                    <h1>{dashboardData[0].applicant_count_selected}</h1>
                  </>
                ) : (
                  ""
                )}
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h3>Shortlisted Applicants</h3>
                  </div>
                  <div>
                    <BsArrowRight size={"30"} />
                  </div>
                </div>
              </div>
            </div>
          </Link>
        </div>
        <div className="col-md-6">
          <Link
            to={"/Candidates/RejectedApplicants"}
            style={{ textDecoration: "none" }}
          >
            <div className="maincontent">
              <div className="recruit_highlight">
                {dashboardData && dashboardData.length !== 0 ? (
                  <>
                    <h1>{dashboardData[0].applicant_count_rejected}</h1>
                  </>
                ) : (
                  ""
                )}
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h3>Rejected Applicants</h3>
                  </div>
                  <div>
                    <BsArrowRight size={"30"} />
                  </div>
                </div>
              </div>
            </div>
          </Link>
        </div>
        <div className="col-md-6">
          <Link
            to={"/Candidates/OnHoldApplicants"}
            style={{ textDecoration: "none" }}
          >
            <div className="maincontent">
              <div className="recruit_highlight">
                {dashboardData && dashboardData.length !== 0 ? (
                  <>
                    <h1>{dashboardData[0].applicant_count_on_hold}</h1>
                  </>
                ) : (
                  ""
                )}
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h3>On-Hold Applicants</h3>
                  </div>
                  <div>
                    <BsArrowRight size={"30"} />
                  </div>
                </div>
              </div>
            </div>
          </Link>
        </div>
      </div>
    </>
  );
}
